import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import tz from "dayjs/plugin/timezone"

// Add timezone support, so everyone gets the same time
dayjs.extend(tz)
dayjs.extend(utc)
dayjs.tz.setDefault("America/New_York")

// Reference:
// https://day.js.org/docs/en/display/format

export function formatDateTime(date: string) {
  return dayjs.tz(date).format("ddd D MMM YYYY h:mma")
}

export function formatNiceDate(date: string) {
  return dayjs.tz(date).format("dddd MMMM D")
}

export function formatShortDate(date: string) {
  return dayjs.tz(date).format("MMMM D YYYY")
}

export function formatNiceTime(date: string) {
  return dayjs.tz(date).format("h:mma").replace(/:00/, "")
}
